/* tslint:disable */
/* eslint-disable */
import { LocalizedTextDisplayModel as AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/localized-text-display-model';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { LocalizedTextDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup } from '@/api/model-index';

export interface ICountryDisplayModel {
  id?: string;
  name?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
}
export class CountryDisplayModel extends BaseModel implements ICountryDisplayModel {
  id?: string;
  name?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
}
class BaseCountryDisplayModelFormGroup extends FormGroup {
  private static _instance: CountryDisplayModelFormGroup;
  
  public static get Instance(): CountryDisplayModelFormGroup {
    this._instance = new CountryDisplayModelFormGroup({
      id: new FormControl(null),
      name: new FormArray([]),
    });

    return this._instance;
  }
}


export class CountryDisplayModelFormGroup extends BaseCountryDisplayModelFormGroup {
  public get Id(): FormControl {
    return this.controls["id"] as FormControl;
  }
  public get Name(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["name"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  

}

export module CountryDisplayModelForm
  {
    export class FormFields
    {
      static _id: string = "id";
      static _name: string = "name";
    }
  }

